<style>

.shoplistbox {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.tr {
	display: flex;
	flex-direction: row;
	align-items: center;
	/* height: 100%; */
	padding: 8px 5px;
}

.tr:not(:last-child) {
	border-bottom: 1px solid #3f8c7e;
}


.left {
  flex-grow: 1;
}

.desc {
	display: flex;
	flex-direction: column;
	height: 100%;
}

/* .desc > div {
	white-space:nowrap;
	overflow:hidden;
	text-overflow:ellipsis;
} */

.one {
	font-weight: 500;
	font-size: 14px;
	text-transform: lowercase;

}

.two {
	font-weight: 400;
	font-size: 13px;
	text-transform: lowercase;
}

.three {
	font-weight: 300;
	font-size: 12px;
	text-transform: capitalize;
}

.one:first-letter,
.two:first-letter {
	text-transform: uppercase;
}

.small-btn {
	font-size: 14px;
}

.desc-item {
	margin-bottom: 4px;
}
.right {
	display: flex;
	flex-direction: column;
	/* height: 100%; */
	align-items: center;
}

.right > div:first-child {
	font-size:0.7em;
	margin-bottom:3px;
}

</style>


<script>

export let nearbymerchant = [];
export let nearbyMerchantsErr = '';
export let isMobileDevice = false;

function launchMap(cordinates) {
	console.log('map open', cordinates);
	const url = 'https://maps.google.com/?q=' + cordinates.latitude + ',' + cordinates.longitude;

		// const url = 'https://www.google.com/maps/search/?api=1&query=' + cordinates.latitude + ',' + cordinates.longitude;
	console.log('============= url ==============', url);
	window.open(url);
	// https://www.google.com/maps/search/?api=1&query=47.5951518,-122.3316393
}

function distRound(dis) {


	if(dis !== undefined) {

		if(dis >= 1) {
			return dis.toFixed(1) + 'km';
		} else {
			const d =  (dis * 1000).toFixed(0);
			if(d<10) {
				return '10m';
			} else { //TODO Accurancy
					return d + 'm';
			}
		}
	}

	return '';
}

</script>

<span class="one">
	{nearbyMerchantsErr}
</span>

<!-- <h1>
	{nearbymerchant.length}
</h1> -->

<div class="shoplistbox">

	{#each nearbymerchant as merchant}

		<div class="tr">

			<div class="left">

				<div class="desc">

					<div class="desc-item one">
						{merchant.shop_name}
					</div>

					<div class="desc-item two">
						{merchant.address}
					</div>

					<div class="desc-item three">
						{(merchant.name).toLocaleLowerCase()},
						

						{#if isMobileDevice}
							<span>
								<a href="tel:{merchant.mobile}">
								+91-{merchant.mobile}												
								</a>
								
							</span>

						{:else}

							<span>
								+91-{merchant.mobile}					
							</span>

						{/if}

					</div>

				</div>

			</div>

			<div class="right">

				<div>
					{distRound(merchant.distance)}
				</div>

				<button small class="small-btn" href="#" on:click|preventDefault={() => launchMap(merchant.location)}>Map</button>


			</div>

		</div>

	{/each}

</div>
